import { h } from "preact";

import IconProps from "./IconProps";

function IconArrowRightWithTail({ color, width, height, class: cssClass }: IconProps) {
    return (
        <svg width={width} height={height} class={cssClass} viewBox="0 0 12 8" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.645.145a.496.496 0 0 1 .701 0L11.85 3.65a.495.495 0 0 1 0 .7L8.346 7.855a.496.496 0 1 1-.7-.701L10.298 4.5H.5a.5.5 0 0 1 0-1h9.8L7.644.846a.496.496 0 0 1 0-.7z" fill={color}/>
        </svg>
    );
}

IconArrowRightWithTail.defaultProps = {
    color: "var(--gandalf)",
    width: 12,
    height: 8
};

export default IconArrowRightWithTail;
